import type { ProgressToWriteRow } from '@ehr/shared';
import { ApiError } from './api.js';

/**
 * ehr#622 - a client's chart opens only for people who can see that client: admins and managers
 * see every client, anyone else the clients they own or that are shared with them. A session a
 * clinician led can still be for a client who isn't theirs. In "View as" this is the viewed-as
 * person's scope.
 */
export const NOT_SHARED_HINT =
  "This client is not shared with you, so their chart can't open. Ask an admin or the client's owner to share it.";

/**
 * A To write row whose chart won't open: Write note says why instead of leaving the user on the
 * Contacts list. A group attendee opens the group workspace, which needs no chart.
 */
export function writeBlocked(row: Pick<ProgressToWriteRow, 'isGroup' | 'canOpen'>): boolean {
  return !row.isGroup && row.canOpen === false;
}

/** What a chart link that didn't open says (the Contacts page shows it; no other client opens). */
export function chartOpenError(e: unknown): string {
  if (e instanceof ApiError && (e.status === 404 || e.status === 403)) return NOT_SHARED_HINT;
  return "Couldn't open that client's chart. Try again.";
}
